import { SegmentsMonthlyVisitsGraphWidget } from "./SegmentsMonthlyVisitsGraphWidget";
import type { DashboardMetric } from "./type";

export class SegmentsVisitDurationGraphWidget extends SegmentsMonthlyVisitsGraphWidget {
    metric: DashboardMetric;

    constructor() {
        super();
        this.metric = "Duration";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsVisitDurationGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsVisitDurationGraphWidget.register();
